import React, { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { RCCAlert, RCCGrid, RCCHookToast, RCCServicesApi} from "react-common-components";
import Loader from "src/components/Loader";
import Title from "src/components/Title";
import { useTranslation } from "src/context/Translations/context";
import { standardErrorMessages } from "src/utils/errors";
import { IMdtba002, IMdtba003, IMdtba004, IRefDiagnosticComparatives, IRefDiagnosticQuestions, IRefDiagnosticTab } from "../../../interface";
import Comparatives from "./comparatives";
import Questions from "./questions";

const TabDiagnostic: React.ForwardRefRenderFunction<IRefDiagnosticTab, { mdtba002: IMdtba002, selectedDiagnostic: number;}> = ({
	selectedDiagnostic,
	mdtba002
}, ref) => {

	const { translate } = useTranslation();
	const { addToast } = RCCHookToast();

	const questionsRef = useRef<IRefDiagnosticQuestions>(null);
	const comparativesRef = useRef<IRefDiagnosticComparatives>(null);


	const [loading, setLoading] = useState(true);
	const [errorLoading, setErrorLoading] = useState(false);

	const [criteriaData, setCriteriaData] = useState<IMdtba002>({} as IMdtba002);
	const [questionsData, setQuestionsData] = useState<IMdtba003[]>([]);
	const [comparativesData, setComparativesData] = useState<IMdtba004[]>([]);

	const openTab = () => {
		questionsRef.current?.reset();
		comparativesRef.current?.reset();
		requestData();
	};

	const requestData = async () => {
		setLoading(true);
		setErrorLoading(false);
		try{
			const { data }  = await RCCServicesApi.getRequest({
				method: "Diagnostics/SelectTab",
				urlParameters: {
					mdb001Id: selectedDiagnostic,
					mda002Id: mdtba002.mda002Id
				}
			});
			setCriteriaData(data.mdtba002);
			setQuestionsData(data.mdtba003);
			setComparativesData(data.mdtba004);
			setLoading(false);
		}catch(err: any){
			setLoading(false);
			setErrorLoading(true);
			standardErrorMessages(err, translate("Erro ao buscar dados"), addToast);
		}
		return null;
	};

	const callbackUpdateComparative = async () => {
		try{
			const { data } = await RCCServicesApi.getRequest({
				method: "Diagnostics/InfosOfComparative",
				urlParameters: {
					mdb001Id: selectedDiagnostic,
					mda002Id: mdtba002.mda002Id
				}
			});
			setComparativesData(data);
		}catch(err){
			standardErrorMessages(err, translate("Erro ao atualizar comparativo, favor atualizar a pagina"), addToast);
		}
	};

	useImperativeHandle(ref, () => ({
		openTab
	}));

	if(loading)
		return <Loader />;
	
	if(errorLoading)
		return <RCCAlert
			color="red"
			title={translate("Atenção")}
			description={translate("Erro ao carregar dados")}
		/>;

	return (
		<>

			<RCCGrid
				container
				item
				style={{ marginBottom: "1rem" }}
			>
				<Title color="grey" size="sm">
					{criteriaData.mda002Descricao}
				</Title>
			</RCCGrid>
			
			<RCCGrid
				container
				item
				style={{ marginBottom: "1rem" }}
			>
				<Comparatives 
					ref={comparativesRef}
					criteria={criteriaData}
					data={comparativesData}
					callbackUpdateComparative={callbackUpdateComparative}
				/>
			</RCCGrid>

			<RCCGrid
				container
				item
			>
				<Questions 
					ref={questionsRef}
					criteria={criteriaData}
					selectedDiagnostic={selectedDiagnostic}
					questionsData={questionsData}
					setQuestionsData={setQuestionsData}
				/>
			</RCCGrid>
		</>
	);
};


export default forwardRef(TabDiagnostic);
